import { Component, OnInit } from "@angular/core";

import { BrowserTitleService } from "../../common/browser-title/browser-title.service";
import { SdpIcon } from "../../common/icon/models";
import { environment } from "environments/environment";

@Component({
	selector: "sdp-home",
	templateUrl: "./home.component.html"
})

export class HomeComponent implements OnInit {
	public readonly helpIcon: SdpIcon.Icon = { type: "material", name: "help", cssClass: "sdp-home-help-icon" };
	public readonly applicationsIcon: SdpIcon.Icon = { type: "material", name: "lock_open", cssClass: "sdp-home-icon" };
	public readonly usersIcon: SdpIcon.Icon = { type: "material", name: "people", cssClass: "sdp-home-icon" };
	public readonly policiesIcon: SdpIcon.Icon = { type: "material", name: "assignment_turned_in", cssClass: "sdp-home-icon" };
	public readonly downloadIcon: SdpIcon.Icon = { type: "material", name: "file_download", cssClass: "sdp-home-icon" };
	public readonly inviteIcon: SdpIcon.Icon = { type: "material", name: "people", cssClass: "sdp-home-icon" };
	public readonly manageIcon: SdpIcon.Icon = { type: "material", name: "assignment_turned_in", cssClass: "sdp-home-icon" };
	public downloadUrl: string;

	constructor(
		private titleService: BrowserTitleService,
	) {
		this.downloadUrl = environment.DOWNLOAD_SITE;
	}

	public ngOnInit() {
		this.titleService.setTitle("home.browser.title");
	}
}
